<template>

    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >

        <rkm-row>

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="{ with_not_regularized: true, with_lotacoes: true }"
                    :searchFields="fields.autocomplete.usuario"
                    text-field="cidadaoNome"
                    :validations="validations.usuario"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="model.usuario"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    defaultOptionText="TODAS"
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    :disabled="!model.usuario || unidades.length === 0"
                    value-field="id"
                    @change="getInfraestruturas()"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Local de atendimento"
                    :options="infraestruturas"
                    textField="nome"
                    defaultOptionText="TODOS"
                    v-model="model.infraestruturaId"
                    :disabled="!model.unidadeId"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>
<script>

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                usuario: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
    },
    created() {

        this.repositories.supervisor = this.getConectaSusRepository('transportePaciente.supervisor'),
        this.repositories.usuario = this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),

        this.load()
    },
    data: () => ({
        repositories: {
            supervisor: null,
            usuario: null,
        },
        form: null,
        model: null,
        unidades: [],
        infraestruturas: []
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.supervisor.edit(this.id) :
                this.repositories.supervisor.create()

            request
                .then(({ data }) => this.setData(data.form || null, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
            }
        },
        save() {
            this.$refs.RkmForm.validate().then(valid => {
                if (valid) {

                    this.setLoading();

                    const modelSnakeCase = this.prepareData();

                    this.getSupervisor().then(response => {

                        if (response.data.id && response.data.id !== this.id) {

                            this.showValidationNotification(`Um supervisor já está registrado para o profissional,
                                com a unidade (<strong>${response.data.unidade}</strong>) e o local de atendimento
                                (<strong>${response.data.infraestrutura}</strong>). Se desejar, por favor, acesse o
                                cadastro do supervisor e faça a alteração necessária.`);
                            this.unsetLoading();
                            return;
                        } else {

                            const request =
                                modelSnakeCase.id === undefined || modelSnakeCase.id === null
                                    ? this.repositories.supervisor.store(modelSnakeCase)
                                    : this.repositories.supervisor.update(modelSnakeCase.id, modelSnakeCase);

                            request
                                .then(response => {
                                    this.showSaveNotification();
                                    this.$emit("save", response);
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading());
                        }
                    });
                }
            });
        },
        getSupervisor() {

            this.setLoading();

            return this.repositories.supervisor.getSupervisor({
                usuario_id: this.model.usuario.id,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
            })
                .then(response => {
                    return response;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        prepareData() {
            const supervisor = this.clone(this.model)

            supervisor.usuarioId = this.trataNull(supervisor.usuario.id)

            delete(supervisor.origemUsuarioId)
            delete(supervisor.usuario)

            return this.camelObjectKeysToSnakeRecursive(supervisor)
        },
        resetForm() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.$nextTick(() => this.$refs.RkmForm.resetValidator())
        },
        getUnidades() {

            this.setLoading()

                this.repositories.supervisor.getUnidades({
                    'usuario_id': this.model.usuario.id
                })
                .then(response => {

                    this.unidades = response.data

                    if (this.model.unidadeId) {

                        this.infraestruturas = this.unidades.find(u => u.id === this.model.unidadeId).infraestruturas
                    }

                    if (this.unidades.length === 0) {

                        this.showAlert(`O profissional não possui nenhuma lotação registrada, portanto, a única opção
                            disponível é cadastrá-lo como supervisor para todas as unidades e locais de atendimento.`,
                            'Atenção')

                        return
                    }

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.resetInfraestrutura()

            if (this.model.unidadeId && this.unidades.length > 0) {

                let infraestruturaPrincipal = this.unidades.find(u => u.id === this.model.unidadeId).infraestruturas

                    this.getPrincipal(infraestruturaPrincipal)

                this.infraestruturas = infraestruturaPrincipal
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal).id
            } else {

                this.resetInfraestrutura()
            }
        },
        resetInfraestrutura() {

            this.model.infraestruturaId = null
        }
    },
    watch: {
        'model.usuario': function (data) {

            if (data && data.id) {

                this.getUnidades()

                if (data.id !== this.model.origemUsuarioId) {

                    this.resetForm()
                }
            } else {
                this.resetForm()
            }
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        id: { type: [Number], default: null }
    },
}
</script>